var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#edit_svg__a)",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.252 2.586A2 2 0 0 1 2.667 2h4.666a.667.667 0 0 1 0 1.333H2.667A.667.667 0 0 0 2 4v9.334a.667.667 0 0 0 .667.666H12a.667.667 0 0 0 .667-.666V8.667a.667.667 0 0 1 1.333 0v4.667a2 2 0 0 1-2 2H2.667a2 2 0 0 1-2-2V4a2 2 0 0 1 .585-1.414Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.333 1.92a.748.748 0 0 0-.528.218L6.602 8.341l-.352 1.41 1.41-.353 6.202-6.203a.747.747 0 0 0-.529-1.276Zm-1.471-.725a2.08 2.08 0 1 1 2.943 2.943L8.47 10.472a.667.667 0 0 1-.31.175l-2.666.667a.667.667 0 0 1-.808-.809l.666-2.667a.667.667 0 0 1 .176-.31l6.333-6.333Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "edit_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
SvgEdit.viewBox = '0 0 16 16';
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export default ForwardRef;